import React from "react";
import { ViewTable } from "@design-system/ViewTable/ViewTable";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { View, ViewType } from "@common/types/views/views";
import {
    phoneNumberSendersViewConfig,
    PhoneNumberSenderColumn,
    PhoneNumberSenderRow,
} from "./phoneNumberSendersViewConfig";

const defaultView: View = {
    type: ViewType.RECEIPT_SENDER,
    columns: [
        { id: PhoneNumberSenderColumn.PHONE_NUMBER },
        { id: PhoneNumberSenderColumn.LIMIT },
        { id: PhoneNumberSenderColumn.ACTIONS, options: { pin: "right" } },
    ],
    filters: {},
    options: {
        selection: false,
        bulkActions: false,
    },
};

interface PhoneNumberSendersViewProps {
    data: PhoneNumberSenderRow[] | null;
}

export const PhoneNumberSendersView: React.FC<PhoneNumberSendersViewProps> = ({
    data,
}) => (
    <ViewTable
        data={data}
        view={defaultView}
        config={phoneNumberSendersViewConfig}
        emptyView={() => (
            <EmptyState
                header="No phone numbers yet"
                body="Add a phone number to submit your receipts via SMS"
            />
        )}
        enableColumnResizing={false}
        outerBorder
    />
);
